export default __webpack_public_path__ + "static/media/slider_image_01-sm@1x.228db56b.jpg";